import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'shellfish',
      d: 'M-2,-1.5h2v0.5h-2zM0.5,-1.5h1.5v0.5h-1.5zM-2.5,-1h5v0.5h-5zM-2.5,-0.5h1.5v0.5h-1.5zM-0.5,-0.5h1.5v0.5h-1.5zM1.5,-0.5h1v0.5h-1zM-1.5,0h1.5v0.5h-1.5zM1,0h1v0.5h-1z',
    },
    { paint: 'sail', d: 'M-1,-0.5h0.5v0.5h-0.5zM1,-0.5h0.5v0.5h-0.5z' },
  ],
  pixels: 32,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
